import { SET_WEBSOCKET } from "./Type";

export function setWekSocket(websocket) {
    return {
        type: SET_WEBSOCKET,
        payload: websocket

    }
}